import { cn } from "@onair/utils/cn";
import Link from "next/link";
interface CardPostProps {
	title?: string;
	description?: string;
	href?: string;
	createdAt?: string;
	thumbnailUrl?: string;
}
const CardPost: React.FC<CardPostProps> = ({
	title = "",
	description = "",
	href = "/",
	createdAt,
	thumbnailUrl,
}) => {
	return (
		<div className="card-post group/item overflow-hidden relative">
			<Link
				href={href}
				className="flex flex-row md:flex-col h-full items-start"
			>
				<div
					className={cn(
						"post-item__thumbnail bg-slate-100 w-full md:max-w-max max-w-[150px] aspect-[9/5] overflow-hidden md:mb-4",
					)}
				>
					<img
						src={thumbnailUrl}
						alt={title}
						className="w-full h-full object-cover"
					/>
				</div>
				<div
					className={cn(
						"post-item__content flex flex-col flex-1",
						"md:pl-0 pl-6",
					)}
				>
					<h3 className="text-sm md:text-lg font-semibold line-clamp-4 leading-snug group-hover/item:underline underline-offset-4">
						{title}
					</h3>
				</div>
			</Link>
		</div>
	);
};
export default CardPost;
